'use client';

import Link from 'next/link';

import { ArrowRight, Calendar, Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { getTrialPeriodDays } from '@kit/shared/config';
import { Trans } from '@kit/ui/trans';
import { cn } from '@kit/ui/utils';

const SIGN_UP_PATH = '/auth/sign-up';

export function FreeTrialCta() {
  const { t } = useTranslation('interactions');
  const days = getTrialPeriodDays();

  return (
    <div className="rounded-lg border-2 border-zinc-800 bg-white p-5 shadow-[4px_4px_0_0_#27272a] dark:border-zinc-200 dark:bg-zinc-900 dark:shadow-[4px_4px_0_0_#e4e4e7]">
      <div className="mb-4 text-center">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border-2 border-zinc-800 bg-zinc-800 px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase dark:border-zinc-200 dark:bg-zinc-200 dark:text-zinc-800">
          <Calendar className="h-3.5 w-3.5" />
          <span>{t('trial.daysFree', { days })}</span>
        </div>
        <h3 className="mb-2 text-xl font-bold text-zinc-800 dark:text-zinc-100">
          {t('trial.title')}
        </h3>
        <p className="text-base leading-relaxed font-light text-zinc-600 dark:text-zinc-400">
          <Trans
            i18nKey="interactions:trial.description"
            values={{ days }}
            components={{
              strong: (
                <strong className="font-medium text-zinc-900 dark:text-zinc-200" />
              ),
            }}
          />
        </p>
      </div>

      <Link
        href={SIGN_UP_PATH}
        className={cn(
          'flex h-12 w-full items-center justify-center gap-2 rounded-lg border-2 border-zinc-800 bg-zinc-800 text-base font-medium text-white',
          'shadow-[3px_3px_0_0_#27272a]',
          'transition-all hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[1px_1px_0_0_#27272a]',
          'dark:border-zinc-200 dark:bg-zinc-200 dark:text-zinc-800',
          'dark:shadow-[3px_3px_0_0_#e4e4e7] dark:hover:shadow-[1px_1px_0_0_#e4e4e7]',
        )}
      >
        <span>{t('trial.cta')}</span>
        <ArrowRight className="h-5 w-5" />
      </Link>

      <div className="mt-4 border-t border-zinc-200 pt-4 dark:border-zinc-700">
        <p className="mb-2 text-center text-sm text-zinc-500 dark:text-zinc-400">
          {t('trial.questions')}
        </p>
        <div className="flex flex-col items-center gap-2 text-sm">
          <a
            href="mailto:jakub@lekolizja.pl"
            className="flex items-center gap-2 text-zinc-600 transition-colors hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-200"
          >
            <Mail className="h-4 w-4" />
            <span>jakub@lekolizja.pl</span>
          </a>
          <a
            href="tel:+48123456789"
            className="flex items-center gap-2 text-zinc-600 transition-colors hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-200"
          >
            <Phone className="h-4 w-4" />
            <span>+48 123 456 789</span>
          </a>
        </div>
      </div>
    </div>
  );
}
